import { render } from "./HolidayDetail.vue?vue&type=template&id=7ed7e59e"
import script from "./HolidayDetail.vue?vue&type=script&lang=js"
export * from "./HolidayDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__